import {SERVER_API_URL} from '../config';
import { errorSweetAlert, oopsSweetAlert } from '../constants';
import swal from 'sweetalert';
import { acquireAccessToken } from '../msalConfig';
import msalInstance from '../msalConfig';

export const fetchMappingTableData = async () => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getMappingFileList", {
            method: "GET",  
            headers: {    
                // Authorization: 'Bearer ' + token,    
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const uploadMappingFile = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/fileUpload", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,     
                'type': 'formData',
            },
            body:formData
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchSheetData = async (page=0,pageSize=20,sheetType,searchByFilter='',searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getSheetData?page="+page+"&pageSize="+pageSize+"&sheet="+sheetType+"&searchBy="+searchByFilter+"&search="+searchValue, {
            method: "GET",  
            headers: {      
                // Authorization: 'Bearer ' + token,   
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchSheetSettingsData = async (sheetType) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getSheetSettingsData?&sheet="+sheetType, {
            method: "GET",  
            headers: {   
                // Authorization: 'Bearer ' + token,      
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const updateSheetSettings = async (selectedSheet,updatedData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        let data = {
            'selectedSheet' : selectedSheet,
            'updatedData'   : updatedData
        }
        const response = await fetch(SERVER_API_URL+"/tool/updateSheetSettings", {
            method: "PUT",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchConnectionSheetData = async (page=0,pageSize=20,sheetType,searchByFilter='',searchValue='') => {
    
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getConnectionSheetData?page="+page+"&pageSize="+pageSize+"&sheet="+sheetType+"&searchBy="+searchByFilter+"&search="+searchValue, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchEventSheetData = async (page=0,pageSize=100,searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getEventSheetData?page="+page+"&pageSize="+pageSize+"&search="+searchValue, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchEventDetails = async (id) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/eventDetails/"+id, {
            method: "GET",  
            headers: {      
                // Authorization: 'Bearer ' + token,   
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchAutoCompleteSheetData = async (regAddress='',sheetType,searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getAutoCompleteSheetData?sheet="+sheetType+"&search="+searchValue+"&regAddress="+regAddress, {
            method: "GET",  
            headers: { 
                // Authorization: 'Bearer ' + token,        
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const syncUploadFileData = async (rowId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        let data = {'rowId' : rowId}
        const response = await fetch(SERVER_API_URL+"/tool/readUploadFile", {
            method: "PUT",  
            headers: {   
                // Authorization: 'Bearer ' + token,      
                'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const downloadMappedFile = async (rowId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/downloadMappedFile/"+rowId, {
            method: "GET",  
            headers : {
                // Authorization: 'Bearer ' + token,   
                'Content-type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
        });
        if(response.status !==  200){
            swal({
                title: 'Oops!',
                text: 'Internal Server Error',
                icon: "error",
                dangerMode: true,
            });
            return;
        } 
        return response;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchAutoCompleteHomePage = async (sheetType,searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getAutoCompleteHomePage?sheet="+sheetType+"&search="+searchValue, {
            method: "GET",  
            headers: { 
                // Authorization: 'Bearer ' + token,        
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getDataForExistingAddresses = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
        //let addresses = {'data' : existingAddresses}
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getModBusDataforExistingAddress", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,   
                'type': 'formData',
            },
            body:formData
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}



export const fetchAutoCompleteDataForECUReceiveMessage = async (searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/autoCompleteDataForECUReceiveMessage?search="+searchValue, {
            method: "GET",  
            headers: { 
                // Authorization: 'Bearer ' + token,        
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const getParamMasterMappingData = async (address) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getParamMasterMappingData?address="+address, {
            method: "GET",  
            headers: { 
                // Authorization: 'Bearer ' + token,        
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getEventsMasterMappingData = async (Eid) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getEventsMasterMappingData?Eid="+Eid, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getDataForExistingEvents = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
        //let events = {'data' : existingEvents}
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getDataForExistingEvents", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,   
                'type': 'formData',
            },
            body:formData
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const uploadConfigFile = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/configFileUpload", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,   
                'type': 'formData',
            },
            body:formData
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const fetchProjectsList = async (page=0,pageSize=20,addedBy='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getProjectsList?page="+page+"&pageSize="+pageSize+"&addedBy="+addedBy, {
            method: "GET",  
            headers: {    
                // Authorization: 'Bearer ' + token,     
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const getConfigFileContentForEditing = async (rowId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/editUploadedConfig?rowId="+rowId, 
        {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,      
                'Content-Type': 'application/json',
            },
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const deleteConfigFile = async (rowId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/deleteConfigFile?rowId="+rowId, 
        {
            method: "DELETE",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const saveContentCloseConfigFile = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/saveContentCloseConfigFile", 
        {
            method: "POST",  
            headers: {    
                // Authorization: 'Bearer ' + token,     
                'type': 'formData',
            },
            body:formData
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const saveContentWorkingConfigFile = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/saveContentWorkingConfigFile", 
        {
            method: "POST",  
            headers: {    
                // Authorization: 'Bearer ' + token,     
                'type': 'formData',
            },
            body:formData
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}

export const closeConfigFile = async (rowId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        let data = {
            'rowId' : rowId,
        }
        const response = await fetch(SERVER_API_URL+"/tool/closeConfigFile", {
            method: "PUT",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
            body:JSON.stringify(data)
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getExistingAddresses = async (existingAddresses) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
        let addresses = {'data' : existingAddresses}
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getModBusExistingAddress", {
            method: "POST",  
            headers: { 
                // Authorization: 'Bearer ' + token,        
                'Content-Type': 'application/json',
            },
            body:JSON.stringify(addresses),
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}



export const fetchReceiveMessageSheetData = async (page=0,pageSize=100,searchValue='') => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getReceiveMessageSheetData?page="+page+"&pageSize="+pageSize+"&search="+searchValue, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}



export const getReceiveMessageMappingData = async (addressId) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getReceiveMessageMappingData?address="+addressId, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getDataForExistingMessage = async (formData) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
        //let events = {'data' : existingEvents}
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getDataForExistingMessages", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,   
                'type': 'formData',
            },
            body:formData
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const sendFeedBackRequest = async (formData) => {
    try { 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/feedBackRequest", {
            method: "POST",  
            headers: {
                // Authorization: 'Bearer ' + token,   
                'type': 'formData',
            },
            body:formData
        });
        const result = await response.json();
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}


export const getAddressDataType = async (address) => {
    try {
        // const localStorageData  = JSON.parse(localStorage.getItem("okta-token-storage"));
        // const token = localStorageData.accessToken.accessToken; 
       //  const token = await acquireAccessToken(msalInstance);
        const response = await fetch(SERVER_API_URL+"/tool/getAddressDataType?address="+address, {
            method: "GET",  
            headers: {  
                // Authorization: 'Bearer ' + token,       
                'Content-Type': 'application/json',
            },
          });
          const result = await response.json();
          if(response.status !== 200){
            oopsSweetAlert(result);
            return;
          }
          return result;
    } catch(error){
        console.log('Error',error);
        errorSweetAlert(error);
    }  
}